import { ConnectionType } from '@/features/print/constants'
import { AnyConnectionOptions } from '@/features/print/types'
import { AddPrinterData } from '@/features/settings/contexts/AddPrinter'

export const createConnectionOptionsFromAddData = (
    addData: AddPrinterData
): AnyConnectionOptions => {
    if (addData.connectionType === ConnectionType.Network) {
        return {
            type: ConnectionType.Network,
            ipAddress: addData.ipAddress,
        }
    }

    if (addData.connectionType === ConnectionType.SunmiDefault) {
        return { type: ConnectionType.SunmiDefault }
    }

    throw new Error('Invalid connection type.')
}
